import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OptimaxService} from '../../../mailing/shared/services/optimax.service';
import {AlertService} from '../../services/alert.service';
import {DocumentService} from '../../../document/shared/services/document.service';
import {DriveItem} from '../../classes/DriveItem';
import {OptimaxDriveContext} from '../../classes/optimaxDriveContext';

@Component({
  selector: 'app-optimax-select-context',
  templateUrl: './optimax-select-context.component.html',
  styleUrls: ['./optimax-select-context.component.css']
})
export class OptimaxSelectContextComponent implements OnInit {

   @Input() resourceType;
   @Input() resourceId;

   drive = 'ms';
   driveSelected: DriveItem = null;
   driveItems: DriveItem[] = [];

   @Output()  abortEvent = new EventEmitter<void>();
   @Output()  submitEvent = new EventEmitter<void>();

  constructor(
      private optimaxService: OptimaxService,
      private alertService: AlertService,
      private documentService: DocumentService
  ) { }

  ngOnInit() {
    this.fetchMsGroups();
  }

  fetchMsGroups() {
    this.documentService.ListDrive().subscribe(response => {
      if (response.status === 200) { //TODO redirect to api connect if not auth
        response.data.forEach(elem => this.driveItems.push(new DriveItem(elem)));
      } else {
        this.alertService.warn(response.message);
      }
    });
  }

  onDriveItemSelect(driveItem: DriveItem) {
    this.driveSelected = driveItem;
  }

  onDriveChange(drive) {
    this.drive = drive;
  }

  onSubmit() {
    if (!this.driveSelected)
      return;
    const optimaxDriveContext = new OptimaxDriveContext();

    optimaxDriveContext.odc_context_type = "groups";
    optimaxDriveContext.odc_context_id = this.driveSelected.id;
    optimaxDriveContext.odc_drive = 'ms';
    optimaxDriveContext.odc_resource_id = this.resourceId;
    optimaxDriveContext.odc_resource_type = this.resourceType;
    optimaxDriveContext.odc_context_libelle = this.driveSelected.name;

    this.optimaxService.insertContext(optimaxDriveContext).subscribe(response => {
      if (response.status !== 200)
        this.alertService.warn(response.message);
      this.submitEvent.emit();
    });
  }

  onAbort() {
    this.abortEvent.emit();
  }
}
